import { Box, Card, Container, Stack, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { env } from '@/config/env';

/** Centered card layout for unauthenticated auth pages (login, reset, verify). */
export function AuthLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Container maxWidth="sm" disableGutters>
        <Stack spacing={3} alignItems="center">
          <Stack spacing={0.5} alignItems="center">
            <Typography variant="h4" fontWeight={800} color="primary">
              {env.appName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Digital marketing agency platform
            </Typography>
          </Stack>
          <Card sx={{ width: '100%', p: { xs: 3, sm: 4 } }}>
            <Outlet />
          </Card>
        </Stack>
      </Container>
    </Box>
  );
}
